import { getMessages } from '../../../../../../../../store/constants';

export const CARD_BLINK_ANIMATION_TIME_ONE = 1000; // same constant in css ./Card.scss
export const CARD_BLINK_ANIMATION_TIME = 2.5 * CARD_BLINK_ANIMATION_TIME_ONE; // hard tune for aging
export const DONE_PROCESSING_STATUS = 'done';
export const CARD_RENDER_MAX_TIME = 5000; // hard tune время для подсчета высота клона

export const CARD_TITLE_EDIT_HINT = getMessages().getText('card_form_name_edit_hint');
